<script>
// A floating action button (FAB) represents the primary action of a screen.
export default {
  name: 'FabButton',
  props: {
    icon: { type: String, required: true },
  },
}
</script>

<template>
  <Button :normal="false" class="fab fab-button" v-on="$listeners">
    <div class="fab-icon-container">
      <transition name="rotate"><Icon :key="icon" :name="icon" class="fab-icon"/></transition>
    </div>
    <slot/>
  </Button>
</template>

<style lang="scss" scoped>

.fab.fab-button {
  @include shadowy-material-fab;
  @include z-index(fab-button);

  @include media(tablet) {
    margin-bottom: $fab-tablet-margin;
    margin-right: $fab-tablet-margin;
  }

  align-content: center;
  background-color: $secondary-color;
  border-radius: $fab-size / 2;
  color: $WHITE;
  display: flex;
  flex-direction: row;
  height: $fab-size;
  justify-content: center;
  margin-bottom: $fab-phone-margin;
  margin-right: $fab-phone-margin;
  min-width: $fab-size;
  opacity: 1;
  padding: 0;
  position: relative;
  transition: color 0.5s ease-out;

  &:hover {
    background-color: $secondary-color-light;
  }

  .fab-icon {
    fill: currentColor;
  }
}

.fab-icon-container {
  height: $fab-icon-size;
  position: relative;
  width: $fab-icon-size;
}

@mixin rotate-transition($timing: 0.2s) {
  .rotate-enter-active,
  .rotate-leave-active {
    bottom: 0;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    transition: opacity $timing ease, transform $timing ease;
  }

  .rotate-enter,
  .rotate-leave-to {
    opacity: 0;
    transform: rotate(90deg);
  }
}

@include rotate-transition;
</style>
